const extractHighlightedText = (
  textNode,
  annotation,
  isFirstNode,
  isLastNode,
) => {
  // Any middle nodes will have all of their text highlighted.
  if (!isFirstNode && !isLastNode) {
    return textNode.text;
  }

  // Determine the character index of the beginning of the highlight.
  const startingCharacterIndex = isFirstNode
    ? annotation.startoffset - textNode.startOffset
    : 0;
  // Determine the character index of the end of the highlight.
  const endingCharacterIndex = isLastNode
    ? annotation.endoffset - textNode.startOffset
    : textNode.text?.length;

  return textNode.text?.slice(startingCharacterIndex, endingCharacterIndex);
};

export default extractHighlightedText;
